// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '셀트리온제약',
  targetSheetName: '한국메딕스 제품리스트',
  headerRowIndex: 10,
  headerRowCount: 1,
  dataStartRowIndex: 11,
  fillMergedDrugNameColumn: true,
  repeatedHeaderRowAction: 'skip',
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제 품 명',
    pharmaceuticalCompanyName: '제 조 사',
    price: '약 가(원)',
    commissionRate: '수수료율1 (기존처방)',
    commissionNote: '비 고',
  },
  requiredHeaders: [
    '제 조 사',
    '제 품 명',
    '성 분 명',
    '함 량',
    '약 가(원)',
    '수수료율1 (기존처방)',
    '추가 수수료 구간분류',
    '보험코드',
    '대 조 약',
    '분류번호',
    '비 고',
  ],
});
